import templateUrl from "servicestack/auto-query/auto-query-criteria.htm";
import horizontalTemplateUrl from "servicestack/auto-query/auto-query-criteria.horizontal.htm";
import extend from "servicestack/basic.controller.properties";
import config from "servicestack/auto-query/auto-query.config";

const SCROLL_DELTA = 180; // TODO: figure out scrollLeft & offsetLeft for "stops"
class controller {
  constructor($element) {
    const $ctrl = this;
    extend(this);
    $ctrl.config = config;
    $ctrl.$element = $element;
    $ctrl.$el = $element[0];
  }

  $onInit() {
    const $ctrl = this;
    $ctrl.$wrapper = $ctrl.$el.querySelectorAll(".aq-filter-list-wrapper")[0];
    $ctrl.$filters = $ctrl.$el.querySelectorAll(".aq-filter");
    $ctrl.$articles = $ctrl.$element.find("article");
    $ctrl.$first = $ctrl.$articles[0];
    // console.debug($ctrl);
  }

  scrollNext() {
    const $ctrl = this;
    if (!$ctrl.$wrapper) $ctrl.$onInit();
    // $ctrl.$wrapper.scrollLeft += SCROLL_DELTA;
    // $ctrl.scroll(true);
    $ctrl.$wrapper.scrollBy({
      top: 0,
      left: SCROLL_DELTA,
      behavior: "smooth",
    });
  }

  scrollPrev() {
    const $ctrl = this;
    if (!$ctrl.$wrapper) $ctrl.$onInit();
    // $ctrl.$wrapper.scrollLeft -= SCROLL_DELTA;
    // $ctrl.scroll(false);
    $ctrl.$wrapper.scrollBy({
      top: 0,
      left: -SCROLL_DELTA,
      behavior: "smooth",
    });
  }

  // revisit later
  scroll(next = true) {
    const $ctrl = this;
    if (!$ctrl.$wrapper) $ctrl.$onInit();
    const $filters = $ctrl.$wrapper.querySelectorAll(".aq-filter");

    for (let i = 0; i < $filters.length; i++) {
      if ($filters[i].offsetLeft > $ctrl.$wrapper.scrollLeft) {
        const ii = next
          ? i
          : i > 0
          ? i - ($filters[i].offsetLeft == $ctrl.$wrapper.scrollLeft ? 2 : 1)
          : 0;
        console.debug(
          "scroll",
          $ctrl.$wrapper.scrollLeft,
          $filters[i].offsetLeft,
          $filters[ii].offsetLeft,
          {
            $ctrl,
            i,
            ii,
            next,
            $filters,
          }
        );
        $ctrl.$wrapper.scrollLeft = $filters[ii].offsetLeft;
        return;
      }
    }
  }
}

export default {
  bindings: {
    panelMaxHeight: "@",
    panelType: "@",
    btnColor: "@",
    btnSize: "@",
    buttonType: "@",
    query: "<",
  },
  controller,
  templateUrl($element, $attrs) {
    return (
      $attrs.templateUrl ||
      ($attrs.layout === "horizontal" ? horizontalTemplateUrl : templateUrl)
    );
  },
};
